module.exports = __webpack_public_path__ + "img/1.105b82dc.webp";